export default [
  {
    path: '/home',
    name: 'Home',
  },
  {
    path: '/school',
    name: 'School',
  },
  {
    path: '/schools',
    name: 'Schools',
  },
  {
    path: '/accounts',
    name: 'Accounts',
  },
  {
    path: '/account',
    name: 'Account',
  },
  {
    path: '/applications/:school_id',
    name: 'Applications',
  },
  {
    path: '/notifications',
    name: 'Notifications',
  },
  {
    path: '/notification',
    name: 'Notification',
  },
  {
    path: '/recompose/:request_code',
    name: 'Recompose',
  },
  {
    path: '/content_master_import',
    name: 'ContentMasterImport',
  },
]
